import { useEffect, useState } from "react";
import { AlertDialog } from "./alertDialog.tsx";
import { incompleteGridMessage, onIncompleteGrid } from "../../util/incompleteData.ts";
import type { GridIncomplete } from "../../types/grid.ts";

/**
 * The popup for grid data that arrived incomplete (see util/incompleteData.ts). Mounted once, in
 * app.tsx, so every grid read gets it. A modal the user must acknowledge — a toast can be missed,
 * and a partial list that looks whole is worse than an error. It names the grid, since a page can
 * hold several. Several at once are shown in turn; the grid itself keeps a warning bar afterwards.
 */
export function IncompleteDataAlert() {
  const [queue, setQueue] = useState<GridIncomplete[]>([]);

  useEffect(() => onIncompleteGrid((info) => setQueue((q) => [...q, info])), []);

  const current = queue[0];
  const grid = current?.grid?.trim() || "this list";
  return (
    <AlertDialog
      open={current !== undefined}
      title={current?.grid ? `Incomplete data: ${current.grid}` : "Data is incomplete"}
      body={
        current && (
          <>
            <p>
              <strong>The data shown in “{grid}” is not complete.</strong>
            </p>
            <p>{incompleteGridMessage(current)}</p>
            <p>Reason: {current.message}</p>
          </>
        )
      }
      acknowledgeOnly
      confirmLabel="I understand"
      onCancel={() => setQueue((q) => q.slice(1))}
      onConfirm={() => setQueue((q) => q.slice(1))}
    />
  );
}
